// What each column means, shown on hover of the info icon beside the column title.

export const EXCALIBUR_COLUMN_INFO = {
    useCase: "Country or tax regime for the report generation.",
    subUseCase: "The kind of report generated.",
    status: "Current status of the request.",
    startTimestamp: "Date and time the request was submitted.",
    createdBy: "Login alias of the user who submitted the request.",
    inputFileKey: "File uploaded for this request.",
    generatedFileKey: "The report generated from the input file.",
    errorDetails: "Why the request failed, if it did. Download error report gives the pre-validation file.",
    txnArtifacts: "Supporting files for this request."
};

export const FILING_COLUMN_INFO = {
    useCase: "Country or tax regime the filing was submitted to.",
    subUseCase: "The kind of filing made for that country.",
    taxIdentifier: "Invoice number or entity code for each filing.",
    status: "Current status of the filing.",
    startTimestamp: "Date and time the filing was submitted.",
    createdBy: "Login of the user who submitted the filing.",
    inputFileKey: "The file submitted for filing.",
    getReceipt: "Proof of submission for this entity.",
    transactionDetails: "How many entities in the filing failed. More Info opens their individual errors.",
    txnArtifacts: "Supporting files for this request."
};

export const TASK_COLUMN_INFO = {
    taskId: "Unique id of this entity's task within the transaction.",
    taxIdentifier: "Invoice number or entity code for each filing.",
    status: "Outcome for this entity.",
    taskInputFile: "The input file used for this entity.",
    submissionReceipt: "Proof of submission for this entity.",
    generatedReport: "The report produced for this entity from its input.",
    errorDetails: "Why this entity failed, if it did."
};

// What each status value means, listed in the Status column's info tooltip; order is roughly the lifecycle.

export const EXCALIBUR_STATUS_INFO = [
    ["INQUEUE", "Request queued, not started yet."],
    ["PROCESSING", "Report generation running."],
    ["SUCCESS", "Report generated, no validation errors."],
    ["CONDITIONAL_SUCCESS", "Report generated, some rows failed pre-validation; see the error report."],
    ["FAILURE", "Generation failed; error report may exist."],
    ["EXCEPTION", "Internal error stopped the run."]
];

export const FILING_STATUS_INFO = [
    ["PROCESSING", "Filing accepted and running."],
    ["SUCCESS", "Every entity filed and accepted."],
    ["PARTIAL_SUCCESS", "Some entities filed, some failed."],
    ["FAILURE", "Filing failed for all entities."],
    ["EXCEPTION", "Internal error stopped the run."],
    ["TRANSMISSION_COMPLETED", "Submitted to downstream."],
    ["PARTIAL_TRANSMISSION_COMPLETED", "Only some entities of the file could be submitted."],
    ["ACCEPTED_WITH_ERRORS", "Authority accepted the submission but reported errors."],
    ["ERROR", "Authority failed to process the submission."],
    ["SUBMITTED", "Submitted to the authority."]
];

export const EXCALIBUR_TASK_STATUS_INFO = [
    ["PROCESSING", "Report generation running."],
    ["SUCCESS", "This entity's file was generated."],
    ["FAILURE", "This entity failed."]
];

export const FILING_TASK_STATUS_INFO = [
    ["PENDING", "Row created, work not finished."],
    ["SUCCESS / ACCEPTED / AUTHORIZED", "This entity was filed and accepted."],
    ["FAILURE", "This entity failed."],
    ["TRANSMISSION_COMPLETED", "Submitted to downstream."],
    ["SUBMITTED", "Submitted to the authority."],
    ["WARNING", "Authority accepted this entity with warnings."],
    ["ERROR", "Authority failed to process this entity."]
];
